import {endpoints} from './endpoints'
import request from '../../request'

export function setApprovalCheck(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setApprovalCheck,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}